import { Layout } from './layout.model';

export class BorderlessLayout implements Layout {
  hasStatusBar: boolean = false;
  hasMenu: boolean = false;
  hasLayout: boolean = false;
  hasLayoutPadding = true;
  autoHideStatusBar = false;
}
